export default class TableDatasource {
  page = 1;
  pages = 1;
  limit = 10;
  sort = null;
  search = null;
  filters = new Map();
  aggregates = null;
  populate = null;
  total = 0;
  active = true;
  load = null;
  docs = [];
  limitOptions = [10, 25, 50, 100];

  constructor(options) {
    Object.assign(this, options);
  }

  async refresh(loadOptions = {}) {
    if (this.load && typeof this.load === 'function') {
      const {
        page = this.page,
        limit = this.limit,
        sort = this.sort,
        search = this.search,
        filters = this.filters,
        aggregates = this.aggregates,
        populate = this.populate
      } = loadOptions;
      const fetchOptions = { page, limit, sort, search, aggregates, populate };
      if (filters) {
        filters.forEach((value, key) => (fetchOptions[key] = value));
      }
      const response = await this.load(fetchOptions);
      if (response) {
        return Object.assign(this, fetchOptions, response);
      } else {
        return Object.assign(this, {
          page: 1,
          pages: 1,
          total: 0,
          docs: []
        });
      }
    }
  }
}
